import type { SignProductOrder } from '@tmh-website/services/electricity-tariff/electricity-tariff.service';

import { cmsWebClient } from '../cms.client.service';

import type {
  GetEmailDoiFlowState,
  GetVoucher,
  PostSubmitContactForm,
  PostVoucherVerify,
  SubmitEmailDoiFlowState,
} from './electricity-tariff.types';

export async function postVoucherVerify(
  props: PostVoucherVerify['props']
): Promise<PostVoucherVerify['response']['success']> {
  const payload: PostVoucherVerify['request']['payload'] = props;

  const response = await cmsWebClient
    .post('electricity-tariff/voucher/verify', { json: payload })
    .json<PostVoucherVerify['response']['success']>();

  return response;
}

export async function getVoucher(props: GetVoucher['props']): Promise<GetVoucher['response']['success']> {
  const payload: GetVoucher['request']['payload'] = props;

  const response = await cmsWebClient
    .post('electricity-tariff/voucher', { json: payload })
    .json<GetVoucher['response']['success']>();

  return response;
}

export async function submitEmailDoiFlow(
  props: SubmitEmailDoiFlowState['props']
): Promise<SubmitEmailDoiFlowState['response']['success']> {
  const payload: SubmitEmailDoiFlowState['request']['payload'] = props;

  const response = await cmsWebClient
    .post('electricity-tariff/email-doi-flow-state', {
      json: payload,
    })
    .json<SubmitEmailDoiFlowState['response']['success']>();

  return response;
}

export async function getEmailDoiFlowState(
  props: GetEmailDoiFlowState['props']
): Promise<GetEmailDoiFlowState['response']['success']> {
  const params: GetEmailDoiFlowState['request']['params'] = props;

  const response = await cmsWebClient
    .get(`electricity-tariff/email-doi-flow-state/${params.token}`)
    .json<GetEmailDoiFlowState['response']['success']>();

  return response;
}

export async function postSubmitContactForm(
  props: PostSubmitContactForm['props']
): Promise<PostSubmitContactForm['response']['success']> {
  const payload: PostSubmitContactForm['request']['payload'] = props;

  const response = await cmsWebClient
    .post('electricity-tariff/contact', { json: payload })
    .json<PostSubmitContactForm['response']['success']>();

  return response;
}

/**
 * Sign Product Order by providing validation code - last step of the Mobilize onboarding
 *
 * @param accessToken - Token needed for authentication in the triPica endpoint
 *
 * @param validationCode - 4-digit code which user gets on their email
 *
 * @param flexCoinValue - Value of the flex coin needed for webhook payload
 */
export async function signProductOrder({
  accessToken,
  validationCode,
  flexCoinValue,
}: SignProductOrder['request']['props']) {
  const response = await cmsWebClient
    .put(`electricity-tariff/mobilize-fr/entry/${accessToken}/sign`, {
      json: { validationCode, flexCoinValue },
      timeout: false,
    })
    .json<SignProductOrder['response']['success']>();

  return response;
}
